import React, { useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";
import { useDispatch } from "react-redux";
import { actualizarFoto } from "../../redux/actions";
import ErrorModal from "../../components/modals/errorModal";
import SuccessModal from "../../components/modals/successModal";
import Button from "../../components/button";

function TakeFotoToDetailComponent({ id, closeTakeFoto, onFotoActualizada }) {
  const webcamRef = useRef(null);
  const [imagen, setImagen] = useState(null);
  const [preview, setPreview] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState({ show: false, message: "" });
  const openErrorModal = (message) => setErrorModal({ show: true, message });
  const closeErrorModal = () => setErrorModal({ show: false, message: "" });
  const dispatch = useDispatch();

  const capturarFoto = async () => {
    const captura = webcamRef.current.getScreenshot();

    if (captura) {
      // Convertir Base64 a Blob
      const blob = await fetch(captura).then(res => res.blob());
      const file = new File([blob], `foto_${Date.now()}.jpeg`, { type: "image/jpeg" });
      setImagen(file);
    }
  };

  useEffect(() => {
    if (imagen) {
      const objectUrl = URL.createObjectURL(imagen);
      setPreview(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    }
  }, [imagen]);

  const handleConfirmar = async () => {
    if (isUploading) return;
    if (!imagen) {
      console.error("No hay imagen capturada");
      return;
    }

    setIsUploading(true);

    try {
      const formData = new FormData();
      formData.append("foto", imagen);
      formData.append("id", id);

      const response = await dispatch(actualizarFoto(formData));

      if (response) {
        setShowSuccessModal(true);
        if (typeof onFotoActualizada === "function") {
          onFotoActualizada();
        }
      } else {
        openErrorModal("Hubo un error al subir la foto.");
      }

      closeTakeFoto();
    } catch (error) {
      console.error(error);
      openErrorModal("Error inesperado");
    } finally {
      setIsUploading(false);
    }
  };

  const closeSuccessModal = () => {
    setShowSuccessModal(false);
  };

  return (
    <div>
      <div
        className="flex min-h-screen flex-col  items-center bg-black/90 inset-0 z-50 fixed"
        onClick={closeTakeFoto} /* Cierra al hacer clic fuera */
      >
        <div className="relative">
          <button
            onClick={closeTakeFoto}
            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
          >
            ✕
          </button>
          {imagen ? (
            <div
              className="flex flex-col  items-center"
              onClick={(e) =>
                e.stopPropagation()
              } /* Evita que el clic dentro lo cierre */
            >
              <img
                src={preview}
                alt="Captura"
                className="mt-[6rem] rounded-lg overflow-hidden"
              />

              <div className=" mt-[5rem] justify-center items-center flex">
                <div className="w-[21.5rem] justify-center items-center gap-2 inline-flex">
                  <Button
                    variant="secondary"
                    size="lg"
                    fullWidth
                    onClick={() => setImagen(null)}
                  >
                    Volver atrás
                  </Button>
                  <Button
                    size="lg"
                    fullWidth
                    onClick={handleConfirmar}
                    loading={isUploading}
                  >
                    Confirmar foto
                  </Button>
                </div>
              </div>
            </div>
          ) : (
            <div
              className="flex flex-col  items-center"
              onClick={(e) =>
                e.stopPropagation()
              } /* Evita que el clic dentro lo cierre */
            >
              <div className="mt-[6rem] rounded-lg overflow-hidden">
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  width={500}
                  videoConstraints={{
                    facingMode: { exact: "environment" } // Usa la cámara trasera
                  }}
                />
              </div>
              <button
                onClick={capturarFoto}
                className="flex flex-col justify-center items-center"
              >
                <div className="w-20 h-20 absolute bg-[#d84e4e] rounded-full border-8 border-white" />
              </button>

              <div className=" mt-[5rem] justify-center items-center flex">
                <div className="w-[21.5rem] justify-center items-center gap-2 inline-flex">
                  <Button
                    variant="secondary"
                    size="lg"
                    fullWidth
                    onClick={() => closeTakeFoto()}
                  >
                    Volver atrás
                  </Button>
                  <Button size="lg" fullWidth disabled>
                    Confirmar foto
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
        {showSuccessModal && (
          <SuccessModal
            closeSuccessModal={closeSuccessModal}
            message="Foto subida con éxito."
          />
        )}
        {errorModal.show && (
          <ErrorModal
            closeErrorModal={closeErrorModal}
            message={errorModal.message}
          />
        )}
      </div>
    </div>
  );
}
export default TakeFotoToDetailComponent;
